import BodyText from '@ancon/wildcat-ui/web/orderweb/BodyText'
import '@ancon/wildcat-ui/web/orderweb/BodyText/BodyText.css'

export default BodyText
